@if (attachments?.length > 0) {
  <div>
    @for (attachment of attachments; track attachment) {
      <div>
        @if (!readonly) {
          <vwui-icon iconName="vwui-trash" (click)="removeAttachment(attachment)"></vwui-icon>
        }
        {{ attachment.originalFileName }}
      </div>
    }
  </div>
}
@if (dropping) {
  <div class="image-file-upload__dropping-container">
    <app-loading-spinner></app-loading-spinner>
  </div>
}
@if (attachments?.length < MAX_ATTACHMENTS && !dropping && !readonly) {
  <div  class="image-file-upload image-file-upload__image-container">
    <ngx-file-drop
      class="image-file-upload__file-drop"
      [showBrowseBtn]="true"
      [accept]="getSupportedExtensions()"
      [disabled]="readonly"
      (onFileDrop)="dropped($event)">
    </ngx-file-drop>
  </div>
}
